<template>
  <apm-bank-transfer v-if="isFurikomi" />
  <tile class="opc-succezz-order" v-else-if="isShowOrderDetails">
    <h2
      class="text-capitalize opc-succezz-order__summary"
      :class="{ 'opc-succezz-order-zuoraoutage__summary': isZuoraOutage, 'opc-succezz-order-zuoraoutage-mobile__summary': isZuoraOutage && $context.is.mobile, }"
      :aria-label="$t('billing.order_summary')"
    >
      {{ $t('billing.order_summary') }}
      <span v-if="isZuoraOutage" class="opc-succezz-order__zuorage-label">{{ $t('billing.zuoraoutage.payment_processing') }}</span>
    </h2>
    <div class="opc-succezz-order__details">
      <div class="opc-succezz-order__details__cart" v-html="cartEle" />
      <open-invoice-cart
        :open-invoice-total-amount="openInvoiceTotalAmount"
        :open-invoice-list="openInvoiceList"
        :open-invoice-original-total-amount="openInvoiceOriginalTotalAmount"
        :current-credit-balance="getterCurrentCreditBalance"
      />
      <div class="opc-succezz-order__details__total" v-html="totalEle" />
    </div>
    <div class="opc-succezz-order__expand">
      <slot />
    </div>
  </tile>
</template>

<script>
import Tile from '@/components/tile.vue';
import { mapGetters } from 'vuex';
import { replaceELement, replaceELementByCallback, removeElementByIndex } from '@/views/succezz/utils';
import ApmBankTransfer from '@/views/success/apm-bank-transfer.vue';
import { subscriptionLevelActionEnum } from '@/views/config/coupon/helper/constant';
import { APM_PAYMENT_METHODS, BILLING_CYCLE, planTypes } from '@/common/constants';
import OpenInvoiceCart from '@/views/config/shopping-cart/open-invoice/open-invoice-cart.vue';

export default {
  components: {
    OpenInvoiceCart,
    Tile,
    ApmBankTransfer,
  },
  computed: {
    ...mapGetters(['persistState', 'couponState']),
    openInvoiceList() {
      return this.persistState.confirmationDetails?.openInvoiceState?.openInvoiceList ?? [];
    },
    openInvoiceTotalAmount() {
      return this.persistState.confirmationDetails?.openInvoiceState?.openInvoiceTotalAmount ?? 0;
    },
    openInvoiceOriginalTotalAmount() {
      return this.persistState.confirmationDetails?.openInvoiceState?.openInvoiceOriginalTotalAmount ?? 0;
    },
    getterCurrentCreditBalance() {
      return this.persistState.confirmationDetails?.openInvoiceState?.getterCurrentCreditBalance ?? 0;
    },
    isZuoraOutage() {
      // ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE
      return (
        this.persistState.confirmationDetails?.isZuoraOutage &&
        this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.ALTERNATIVE_CREDIT_CARD
      );
    },
    isFurikomi() {
      return (
        !!this.persistState.confirmationDetails?.isAPM &&
        this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.FURIKOMI
      );
    },
    isShowOrderDetails() {
      return !!this.cartEle;
    },
    isPrecise() {
      return this.persistState.confirmationDetails?.isPrecise;
    },
    cartEle() {
      return this.persistState?.confirmationDetails?.cartEle;
    },
    submitELe() {
      const html = this.persistState?.confirmationDetails?.submitEle;
      if (!html) return false;
      return html + `<div class='opc-cart__main__divider'></div>`;
    },
    getSelectedPlans() {
      return this.persistState.confirmationDetails?.getSelectedPlans ?? [];
    },
    isInsertTotalEleIfPPA() {
      if (!this.submitELe) return false;
      const hasPPA = this.getSelectedPlans.find(p => p.billing_cycle === BILLING_CYCLE.PAY_PER_ATTENDEE);
      return hasPPA && (this.$context.is.add2cart || this.$context.is.zs2ze || this.$context.is.switch);
    },
    isInsertTotalEle() {
      if (!this.submitELe) return false;
      if (this.persistState.confirmationDetails?.onSessionPaymentEnabled) return false;
      return this.persistState.confirmationDetails?.discountWithAmountMap?.totalDiscount > 0;
    },
    totalEle() {
      let html = this.persistState?.confirmationDetails?.totalEle;
      if (this.isPrecise) {
        const tempEle = document.createElement('div');
        tempEle.innerHTML = html;

        replaceELement(tempEle, '.__PLACEHOLDER_total__today', this.$t('billing.order_summary.todays_total'));
        replaceELementByCallback(tempEle, '.__PLACEHOLDER_total__desc', (ele) => {
          ele.innerHTML = '';
          ele.style.display = 'none';
        });

        if (this.$context.type === planTypes.VIDEO_SDK) {
          removeElementByIndex(tempEle, '.opc-cart__main__divider', -1);
        }

        html = tempEle.innerHTML;
      }
      // replace coupon case
      if (
        this.isInsertTotalEleIfPPA || (this.isInsertTotalEle &&
        (this.couponState.subscriptionLevelAction === subscriptionLevelActionEnum.replaceSubscription))) {
        const tempEle = document.createElement('div');
        tempEle.innerHTML = html;
        const ele = tempEle.querySelector('.__PLACEHOLDER_0__');
        ele.innerHTML = this.submitELe;
        ele.style.display = 'block';
        ele.classList.add('opc-cart__submit__label');
        html = tempEle.innerHTML;
      }
      return html;
    },
  },
  mounted() {
    document.querySelectorAll('.tooltip-container').forEach(container => {
      const tooltip = container.querySelector('.tooltip');
      const position = container.getAttribute('data-position') || 'top';
      tooltip.setAttribute('data-position', position);

      container.addEventListener('mouseenter', () => {
        console.log('container: show', tooltip);
        tooltip.classList.add('show');
      });
      container.addEventListener('mouseleave', () => {
        console.log('container: hide', tooltip);
        tooltip.classList.remove('show');
      });
    });
  },
};
</script>

<style lang="scss">
@import '@/views/config/shopping-cart/index.scss';
@import '@/views/config/shopping-cart/total.scss';
@import '@/views/config/shopping-cart/description.scss';
@import '@/views/config/shopping-cart/next-scope.scss';
@import '@/views/config/shopping-cart/next.scss';
@import '@/views/config/shopping-cart/prorated-charge';
@import '@/views/config/shopping-cart/inr-discount/index.scss';
@import '@/views/config/shopping-cart/refer-a-friend-discount/index.scss';
@import '@/views/config/shopping-cart/refer-a-friend-referral-credit/index.scss';

.opc-cart__description {
  margin: 24px 0;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  border-radius: 8px;
  background: var(--day-background-background, #FFF);
  box-shadow: 0 2px 12px 0 rgba(35, 35, 51, .5);
  border: 1px solid transparent;
  padding: 16px;
  white-space: nowrap;
  font-size: 14px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 10;
}
.tooltip p {
  color: var(--day-foreground-foreground-ada, #666487);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  text-transform: none;
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 100%; /* 箭头在 tooltip 底部 */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

.tooltip[data-position="top"] {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
}

.tooltip[data-position="bottom"] {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(8px);
}

.tooltip[data-position="left"] {
  right: 100%;
  top: 50%;
  transform: translateX(-8px) translateY(-50%);
}

.tooltip[data-position="right"] {
  left: 100%;
  top: 50%;
  transform: translateX(8px) translateY(-50%);
}

.tooltip.show {
  opacity: 1;
  pointer-events: auto;
}
</style>

<style scoped lang="scss">
.opc-succezz-order {
  &__details {
    border-top: 1px solid #dfdfe4;
    padding-top: 18px;
    margin-top: 18px;
  }

  /deep/ .__PLACEHOLDER_coupon__ {
    display: none;
  }

  /deep/ .zm-button:not(.opc-success-no-hide-button) {
    display: none;
  }

  /deep/ .only-show-in-success {
    display: block;
    &.inline-block {
      display: inline-block;
    }
  }

  /deep/ .hide-in-success {
    display: none;
  }

  /deep/ .zm-tooltip {
    display: none;
  }

  &__expand {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .opc-succezz-order-zuoraoutage__summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .opc-succezz-order-zuoraoutage-mobile__summary {
    flex-direction: column;
    align-items: flex-start;

    .opc-succezz-order__zuorage-label {
      margin-top: 5px;
    }
  }
  .opc-succezz-order__summary {
    font-size: 24px;
    font-weight: 500;
    // ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE
    .opc-succezz-order__zuorage-label {
      color: #894c01;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: center;
      border: 1px solid #f0dcc4;
      background-color: #fff9f2;
      border-radius: 100px;
      padding: 0 4px;
    }
  }

  /deep/ .opc-cart-item__title .opc-cart-item__value {
    padding-left: 24px;
  }
}
</style>
